<template>
  <v-app-bar dense dark>
    <v-btn icon>
      <v-icon @click="goToHome">mdi-home</v-icon>
    </v-btn>
    <v-toolbar-title>{{getTitle}}</v-toolbar-title>
  </v-app-bar>
</template>

<script>
import { assetNameToText } from '../../util/tool'

export default {
  computed: {
    getTitle() {
      return assetNameToText(this.$route.params.type)
    }
  },
  data() {
    return {
      activeBottomBar: this.$route.name === 'DbAsMy' ? 'my' : 'ground'
    }
  },
  name: 'DbAsFooter',
  methods: {
    goToHome() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>
<style scoped>
.float-btn {
  top: -120px !important;
}
</style>